export default __webpack_public_path__ + "static/media/smartphone.d1e85168.svg";